const problems = [
  {
    id: 1,
    title: "Two Sum",
    difficulty: "Easy",
    topics: ["Array", "Hash Table"],
    companies: ["Uber", "Amazon", "Netflix", "Microsoft"],
    status: "Solved",
    points: 10,
    leetcodeUrl: "https://leetcode.com/problems/two-sum/",
    videoUrl: "https://youtu.be/UXDSeD9mN-k",
    notesUrl: "https://takeuforward.org/data-structure/two-sum-check-if-a-pair-with-given-sum-exists-in-array/",
    hasDiscussion: true
  },
  {
    id: 2,
    title: "Find the Missing Number",
    difficulty: "Easy",
    topics: ["Array", "Math", "Bit Manipulation"],
    companies: ["Microsoft", "Amazon", "Walmart"],
    status: "Solved",
    points: 10,
    platform: "CodingNinjas",
    platformUrl: "https://www.codingninjas.com/studio/problems/missing-number_6680467",
    videoUrl: "https://www.youtube.com/watch?v=bYWLJb3vCWY",
    notesUrl: "https://takeuforward.org/arrays/find-the-missing-number-in-an-array/",
    hasDiscussion: true
  },
  {
    id: 3,
    title: "Add Two Numbers",
    difficulty: "Medium",
    topics: ["Linked List", "Math", "Recursion"],
    companies: ["Twitter", "LinkedIn", "Airbnb", "Google"],
    status: "Attempted",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/add-two-numbers/",
    videoUrl: "https://youtu.be/LBVsXSMOIk4",
    notesUrl: "https://takeuforward.org/data-structure/add-two-numbers-represented-as-linked-lists/",
    hasDiscussion: true
  },
  {
    id: 4,
    title: "Chocolate Distribution Problem",
    difficulty: "Easy",
    topics: ["Array", "Sorting", "Greedy"],
    companies: ["Amazon", "Adobe", "Flipkart"],
    status: "Unsolved",
    points: 10,
    platform: "GeeksforGeeks",
    platformUrl: "https://www.geeksforgeeks.org/problems/chocolate-distribution-problem3825/1",
    videoUrl: "https://www.youtube.com/watch?v=7jdcn5fNVJU",
    notesUrl: "https://www.geeksforgeeks.org/chocolate-distribution-problem/",
    hasDiscussion: true
  },
  {
    id: 5,
    title: "Longest Substring Without Repeating Characters",
    difficulty: "Medium",
    topics: ["Hash Table", "Two Pointers", "String", "Sliding Window"],
    companies: ["Facebook", "Oracle", "Twitter", "Adobe"],
    status: "Unsolved",
    points: 20,
    leetcodeUrl: "https://leetcode.com/problems/longest-substring-without-repeating-characters/",
    videoUrl: "https://youtu.be/qtVh-XEpsJo",
    notesUrl: "https://takeuforward.org/data-structure/length-of-longest-substring-without-any-repeating-character/",
    hasDiscussion: true
  },
  {
    id: 6,
    title: "Sort 0s 1s and 2s",
    difficulty: "Easy",
    topics: ["Array", "Two Pointers", "Sorting"],
    companies: ["Microsoft", "Amazon", "Samsung"],
    status: "Solved",
    points: 10,
    platform: "GeeksforGeeks",
    platformUrl: "https://www.geeksforgeeks.org/problems/sort-an-array-of-0s-1s-and-2s4231/1",
    videoUrl: "https://www.youtube.com/watch?v=oaVa-9wmpns",
    notesUrl: "https://takeuforward.org/data-structure/sort-an-array-of-0s-1s-and-2s/",
    hasDiscussion: true
  },
  {
    id: 7,
    title: "Median of Two Sorted Arrays",
    difficulty: "Hard",
    topics: ["Array", "Binary Search", "Divide and Conquer"],
    companies: ["Microsoft", "LinkedIn", "Apple", "Google"],
    status: "Unsolved",
    points: 25,
    leetcodeUrl: "https://leetcode.com/problems/median-of-two-sorted-arrays/",
    videoUrl: "https://youtu.be/NTop3VTjmxk",
    notesUrl: "https://takeuforward.org/data-structure/median-of-two-sorted-arrays-of-different-sizes/",
    hasDiscussion: true
  },
  {
    id: 8,
    title: "Count Inversions",
    difficulty: "Medium",
    topics: ["Array", "Merge Sort", "Divide and Conquer"],
    companies: ["Amazon", "Microsoft", "Google"],
    status: "Unsolved",
    points: 20,
    platform: "GeeksforGeeks",
    platformUrl: "https://www.geeksforgeeks.org/problems/inversion-of-array-1587115620/1",
    videoUrl: "https://www.youtube.com/watch?v=kQ1mJlwW-c0",
    notesUrl: "https://takeuforward.org/data-structure/count-inversions-in-an-array/",
    hasDiscussion: true
  },
  {
    id: 9,
    title: "Longest Palindromic Substring",
    difficulty: "Medium",
    topics: ["String", "Dynamic Programming"],
    companies: ["Amazon", "Uber", "Airbnb", "Adobe"],
    status: "Attempted",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/longest-palindromic-substring/",
    videoUrl: "https://youtu.be/UflHuQj6MVA",
    notesUrl: "https://takeuforward.org/data-structure/longest-palindromic-substring-dp-5/",
    hasDiscussion: true
  },
  {
    id: 10,
    title: "Longest Consecutive Sequence",
    difficulty: "Medium",
    topics: ["Array", "Hash Table", "Union Find"],
    companies: ["Google", "Facebook", "Amazon"],
    status: "Attempted",
    points: 20,
    platform: "CodingNinjas",
    platformUrl: "https://www.codingninjas.com/studio/problems/longest-consecutive-sequence_6811740",
    videoUrl: "https://www.youtube.com/watch?v=qgizvmgeyUM",
    notesUrl: "https://takeuforward.org/data-structure/longest-consecutive-sequence-in-an-array/",
    hasDiscussion: true
  },
  {
    id: 11,
    title: "ZigZag Conversion",
    difficulty: "Medium",
    topics: ["String"],
    companies: ["Facebook", "Oracle", "Adobe", "Netflix"],
    status: "Unsolved",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/zigzag-conversion/",
    videoUrl: "https://youtu.be/Q2Tw6gcVEwc",
    notesUrl: "https://leetcode.com/problems/zigzag-conversion/solution/",
    hasDiscussion: true
  },
  {
    id: 12,
    title: "Kadane's Algorithm",
    difficulty: "Medium",
    topics: ["Array", "Dynamic Programming"],
    companies: ["Amazon", "Microsoft", "Flipkart"],
    status: "Solved",
    points: 15,
    platform: "GeeksforGeeks",
    platformUrl: "https://www.geeksforgeeks.org/problems/kadanes-algorithm-1587115620/1",
    videoUrl: "https://www.youtube.com/watch?v=AHZpyENo7k4",
    notesUrl: "https://takeuforward.org/data-structure/kadanes-algorithm-maximum-subarray-sum-in-an-array/",
    hasDiscussion: true
  },
  {
    id: 13,
    title: "Reverse Integer",
    difficulty: "Easy",
    topics: ["Math"],
    companies: ["Apple", "Netflix", "Microsoft", "Airbnb"],
    status: "Solved",
    points: 10,
    leetcodeUrl: "https://leetcode.com/problems/reverse-integer/",
    videoUrl: "https://youtu.be/CRgXSC3baTU",
    notesUrl: "https://leetcode.com/problems/reverse-integer/solution/",
    hasDiscussion: true
  },
  {
    id: 14,
    title: "Stock Buy and Sell",
    difficulty: "Medium",
    topics: ["Array", "Dynamic Programming", "Greedy"],
    companies: ["Amazon", "Paytm", "Flipkart"],
    status: "Attempted",
    points: 15,
    platform: "GeeksforGeeks",
    platformUrl: "https://www.geeksforgeeks.org/problems/stock-buy-and-sell-1587115621/1",
    videoUrl: "https://www.youtube.com/watch?v=excAOvwF_Wk",
    notesUrl: "https://takeuforward.org/data-structure/stock-buy-and-sell/",
    hasDiscussion: true
  },
  {
    id: 15,
    title: "String to Integer (atoi)",
    difficulty: "Medium",
    topics: ["String", "Math"],
    companies: ["Amazon", "Twitter", "LinkedIn", "Google"],
    status: "Unsolved",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/string-to-integer-atoi/",
    videoUrl: "https://youtu.be/sfZ7_KEF18Q",
    notesUrl: "https://takeuforward.org/data-structure/implement-atoi-string-to-integer/",
    hasDiscussion: true
  },
  {
    id: 16,
    title: "Subarray with Given Sum",
    difficulty: "Easy",
    topics: ["Array", "Hash Table", "Sliding Window"],
    companies: ["Amazon", "Microsoft", "Accenture"],
    status: "Solved",
    points: 10,
    platform: "GeeksforGeeks",
    platformUrl: "https://www.geeksforgeeks.org/problems/subarray-with-given-sum-1587115621/1",
    videoUrl: "https://www.youtube.com/watch?v=frf7qxiN2qU",
    notesUrl: "https://www.geeksforgeeks.org/find-subarray-with-given-sum/",
    hasDiscussion: true
  },
  {
    id: 17,
    title: "Container With Most Water",
    difficulty: "Medium",
    topics: ["Array", "Two Pointers"],
    companies: ["Facebook", "Uber", "Oracle", "Airbnb"],
    status: "Attempted",
    points: 20,
    leetcodeUrl: "https://leetcode.com/problems/container-with-most-water/",
    videoUrl: "https://youtu.be/w7ftz8nZF80",
    notesUrl: "https://takeuforward.org/data-structure/container-with-most-water/",
    hasDiscussion: true
  },
  {
    id: 18,
    title: "Job Sequencing Problem",
    difficulty: "Medium",
    topics: ["Array", "Greedy", "Sorting"],
    companies: ["Flipkart", "Samsung", "Amazon"],
    status: "Unsolved",
    points: 20,
    platform: "GeeksforGeeks",
    platformUrl: "https://www.geeksforgeeks.org/problems/job-sequencing-problem-1587115620/1",
    videoUrl: "https://www.youtube.com/watch?v=LjPx4wQaRIs",
    notesUrl: "https://takeuforward.org/data-structure/job-sequencing-problem/",
    hasDiscussion: true
  },
  {
    id: 19,
    title: "Integer to Roman",
    difficulty: "Medium",
    topics: ["Math", "String"],
    companies: ["Uber", "Amazon", "Apple", "Facebook"],
    status: "Unsolved",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/integer-to-roman/",
    videoUrl: "https://youtu.be/Oh89dyD1Xy8",
    notesUrl: "https://leetcode.com/problems/integer-to-roman/solution/",
    hasDiscussion: true
  },
  {
    id: 20,
    title: "N Queen Problem",
    difficulty: "Hard",
    topics: ["Backtracking", "Recursion"],
    companies: ["Google", "Amazon", "Microsoft"],
    status: "Unsolved",
    points: 25,
    platform: "CodingNinjas",
    platformUrl: "https://www.codingninjas.com/studio/problems/n-queens_696453",
    videoUrl: "https://www.youtube.com/watch?v=i05Ju7AftcM",
    notesUrl: "https://takeuforward.org/data-structure/n-queen-problem-return-all-distinct-solutions-to-the-n-queens-puzzle/",
    hasDiscussion: true
  },
  {
    id: 21,
    title: "Roman to Integer",
    difficulty: "Easy",
    topics: ["Hash Table", "Math", "String"],
    companies: ["Adobe", "Twitter", "Google", "Microsoft"],
    status: "Solved",
    points: 10,
    leetcodeUrl: "https://leetcode.com/problems/roman-to-integer/",
    videoUrl: "https://youtu.be/3jdxYj3DD98",
    notesUrl: "https://leetcode.com/problems/roman-to-integer/solution/",
    hasDiscussion: true
  },
  {
    id: 22,
    title: "Rat in a Maze",
    difficulty: "Medium",
    topics: ["Backtracking", "Matrix", "Recursion"],
    companies: ["Microsoft", "Amazon", "Samsung"],
    status: "Attempted",
    points: 15,
    platform: "GeeksforGeeks",
    platformUrl: "https://www.geeksforgeeks.org/problems/rat-in-a-maze-problem/1",
    videoUrl: "https://www.youtube.com/watch?v=bLGZhJlt4y0",
    notesUrl: "https://takeuforward.org/data-structure/rat-in-a-maze/",
    hasDiscussion: true
  },
  {
    id: 23,
    title: "Longest Common Prefix",
    difficulty: "Easy",
    topics: ["String"],
    companies: ["LinkedIn", "Oracle", "Netflix", "Apple"],
    status: "Solved",
    points: 10,
    leetcodeUrl: "https://leetcode.com/problems/longest-common-prefix/",
    videoUrl: "https://youtu.be/0sWShKIJoo4",
    notesUrl: "https://takeuforward.org/data-structure/longest-common-prefix/",
    hasDiscussion: true
  },
  {
    id: 24,
    title: "Word Break",
    difficulty: "Medium",
    topics: ["String", "Dynamic Programming", "Backtracking"],
    companies: ["Google", "Amazon", "Facebook"],
    status: "Attempted",
    points: 20,
    platform: "CodingNinjas",
    platformUrl: "https://www.codingninjas.com/studio/problems/word-break_630476",
    videoUrl: "https://www.youtube.com/watch?v=s9fokUqJ76A",
    notesUrl: "https://takeuforward.org/data-structure/word-break-ii-dp-51/",
    hasDiscussion: true
  },
  {
    id: 25,
    title: "3Sum",
    difficulty: "Medium",
    topics: ["Array", "Two Pointers"],
    companies: ["Oracle", "Facebook", "Google", "Airbnb"],
    status: "Attempted",
    points: 20,
    leetcodeUrl: "https://leetcode.com/problems/3sum/",
    videoUrl: "https://youtu.be/DhFh8Kw7ymk",
    notesUrl: "https://takeuforward.org/data-structure/3-sum-find-triplets-that-sum-to-zero/",
    hasDiscussion: true
  },
  {
    id: 26,
    title: "Edit Distance",
    difficulty: "Hard",
    topics: ["String", "Dynamic Programming"],
    companies: ["Google", "Facebook", "Microsoft"],
    status: "Unsolved",
    points: 25,
    platform: "GeeksforGeeks",
    platformUrl: "https://www.geeksforgeeks.org/problems/edit-distance3702/1",
    videoUrl: "https://www.youtube.com/watch?v=fJaKO8FbDdo",
    notesUrl: "https://takeuforward.org/data-structure/edit-distance-dp-33/",
    hasDiscussion: true
  },
  {
    id: 27,
    title: "3Sum Closest",
    difficulty: "Medium",
    topics: ["Array", "Two Pointers"],
    companies: ["Uber", "Microsoft", "Amazon", "LinkedIn"],
    status: "Unsolved",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/3sum-closest/",
    videoUrl: "https://youtu.be/qBr2Ih410xE",
    notesUrl: "https://leetcode.com/problems/3sum-closest/solution/",
    hasDiscussion: true
  },
  {
    id: 28,
    title: "Longest Common Subsequence",
    difficulty: "Medium",
    topics: ["String", "Dynamic Programming"],
    companies: ["Amazon", "Microsoft", "Samsung"],
    status: "Attempted",
    points: 15,
    platform: "CodingNinjas",
    platformUrl: "https://www.codingninjas.com/studio/problems/longest-common-subsequence_624879",
    videoUrl: "https://www.youtube.com/watch?v=NPZn9jBrX8U",
    notesUrl: "https://takeuforward.org/data-structure/longest-common-subsequence-dp-25/",
    hasDiscussion: true
  },
  {
    id: 29,
    title: "Letter Combinations of a Phone Number",
    difficulty: "Medium",
    topics: ["String", "Backtracking", "Recursion"],
    companies: ["Twitter", "Netflix", "Adobe", "Facebook"],
    status: "Attempted",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/letter-combinations-of-a-phone-number/",
    videoUrl: "https://youtu.be/0snEunUacZY",
    notesUrl: "https://leetcode.com/problems/letter-combinations-of-a-phone-number/solution/",
    hasDiscussion: true
  },
  {
    id: 30,
    title: "0-1 Knapsack Problem",
    difficulty: "Medium",
    topics: ["Dynamic Programming", "Array"],
    companies: ["Amazon", "Microsoft", "Flipkart"],
    status: "Attempted",
    points: 20,
    platform: "GeeksforGeeks",
    platformUrl: "https://www.geeksforgeeks.org/problems/0-1-knapsack-problem0945/1",
    videoUrl: "https://www.youtube.com/watch?v=GqOmJHQZivw",
    notesUrl: "https://takeuforward.org/data-structure/0-1-knapsack-dp-19/",
    hasDiscussion: true
  },
  {
    id: 31,
    title: "4Sum",
    difficulty: "Medium",
    topics: ["Array", "Hash Table", "Two Pointers"],
    companies: ["Adobe", "Apple", "Amazon", "Google"],
    status: "Unsolved",
    points: 20,
    leetcodeUrl: "https://leetcode.com/problems/4sum/",
    videoUrl: "https://youtu.be/eD95WRfh81c",
    notesUrl: "https://takeuforward.org/data-structure/4-sum-find-quadruplets-that-sum-to-target-value/",
    hasDiscussion: true
  },
  {
    id: 32,
    title: "Coin Change",
    difficulty: "Medium",
    topics: ["Array", "Dynamic Programming"],
    companies: ["Amazon", "Microsoft", "Google"],
    status: "Attempted",
    points: 15,
    platform: "CodingNinjas",
    platformUrl: "https://www.codingninjas.com/studio/problems/coin-change_624662",
    videoUrl: "https://www.youtube.com/watch?v=HgyouUi11zk",
    notesUrl: "https://takeuforward.org/data-structure/coin-change-2-dp-22/",
    hasDiscussion: true
  },
  {
    id: 33,
    title: "Remove Nth Node From End of List",
    difficulty: "Medium",
    topics: ["Linked List", "Two Pointers"],
    companies: ["Uber", "LinkedIn", "Apple", "Netflix"],
    status: "Attempted",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/remove-nth-node-from-end-of-list/",
    videoUrl: "https://youtu.be/3kMKYQ2wNIU",
    notesUrl: "https://takeuforward.org/data-structure/remove-nth-node-from-end-of-linked-list/",
    hasDiscussion: true
  },
  {
    id: 34,
    title: "Matrix Chain Multiplication",
    difficulty: "Hard",
    topics: ["Dynamic Programming"],
    companies: ["Amazon", "Samsung", "Microsoft"],
    status: "Unsolved",
    points: 25,
    platform: "GeeksforGeeks",
    platformUrl: "https://www.geeksforgeeks.org/problems/matrix-chain-multiplication0303/1",
    videoUrl: "https://www.youtube.com/watch?v=vRVfmbCFW7Y",
    notesUrl: "https://takeuforward.org/dynamic-programming/matrix-chain-multiplication-dp-48/",
    hasDiscussion: true
  },
  {
    id: 35,
    title: "Valid Parentheses",
    difficulty: "Easy",
    topics: ["String", "Stack"],
    companies: ["Microsoft", "Twitter", "Oracle", "Adobe"],
    status: "Solved",
    points: 10,
    leetcodeUrl: "https://leetcode.com/problems/valid-parentheses/",
    videoUrl: "https://youtu.be/wkDfsKijrZ8",
    notesUrl: "https://takeuforward.org/data-structure/check-for-balanced-parentheses/",
    hasDiscussion: true
  },
  {
    id: 36,
    title: "Implement Stack using Queue",
    difficulty: "Easy",
    topics: ["Stack", "Queue", "Design"],
    companies: ["Microsoft", "Amazon", "Adobe"],
    status: "Solved",
    points: 10,
    platform: "CodingNinjas",
    platformUrl: "https://www.codingninjas.com/studio/problems/stack-using-queue_795152",
    videoUrl: "https://www.youtube.com/watch?v=jDZQKzEtbYU",
    notesUrl: "https://takeuforward.org/data-structure/implement-stack-using-single-queue/",
    hasDiscussion: true
  },
  {
    id: 37,
    title: "Merge Two Sorted Lists",
    difficulty: "Easy",
    topics: ["Linked List", "Recursion"],
    companies: ["Oracle", "Airbnb", "Twitter", "Amazon"],
    status: "Solved",
    points: 10,
    leetcodeUrl: "https://leetcode.com/problems/merge-two-sorted-lists/",
    videoUrl: "https://youtu.be/XIdigk956u0",
    notesUrl: "https://takeuforward.org/data-structure/merge-two-sorted-linked-lists/",
    hasDiscussion: true
  },
  {
    id: 38,
    title: "Implement Queue using Stack",
    difficulty: "Easy",
    topics: ["Stack", "Queue", "Design"],
    companies: ["Microsoft", "Amazon", "Goldman Sachs"],
    status: "Solved",
    points: 10,
    platform: "GeeksforGeeks",
    platformUrl: "https://www.geeksforgeeks.org/problems/queue-using-two-stacks/1",
    videoUrl: "https://www.youtube.com/watch?v=3Et9MrMc02A",
    notesUrl: "https://takeuforward.org/data-structure/implement-queue-using-stack/",
    hasDiscussion: true
  },
  {
    id: 39,
    title: "Generate Parentheses",
    difficulty: "Medium",
    topics: ["String", "Backtracking", "Recursion"],
    companies: ["LinkedIn", "Facebook", "Uber", "Apple"],
    status: "Attempted",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/generate-parentheses/",
    videoUrl: "https://youtu.be/s9fokUqJ76A",
    notesUrl: "https://leetcode.com/problems/generate-parentheses/solution/",
    hasDiscussion: true
  },
  {
    id: 40,
    title: "Min Stack",
    difficulty: "Easy",
    topics: ["Stack", "Design"],
    companies: ["Amazon", "Adobe", "Flipkart"],
    status: "Solved",
    points: 10,
    platform: "CodingNinjas",
    platformUrl: "https://www.codingninjas.com/studio/problems/min-stack_3843991",
    videoUrl: "https://www.youtube.com/watch?v=V09NfaGf2ao",
    notesUrl: "https://takeuforward.org/data-structure/implement-min-stack-o2n-and-on-space-complexity/",
    hasDiscussion: true
  },
  {
    id: 41,
    title: "Merge k Sorted Lists",
    difficulty: "Hard",
    topics: ["Linked List", "Divide and Conquer", "Heap"],
    companies: ["Netflix", "Microsoft", "Airbnb", "Apple"],
    status: "Unsolved",
    points: 25,
    leetcodeUrl: "https://leetcode.com/problems/merge-k-sorted-lists/",
    videoUrl: "https://youtu.be/kpCesr9SXJY",
    notesUrl: "https://leetcode.com/problems/merge-k-sorted-lists/solution/",
    hasDiscussion: true
  },
  {
    id: 42,
    title: "Next Greater Element",
    difficulty: "Medium",
    topics: ["Array", "Stack", "Monotonic Stack"],
    companies: ["Amazon", "Microsoft", "Flipkart"],
    status: "Attempted",
    points: 15,
    platform: "GeeksforGeeks",
    platformUrl: "https://www.geeksforgeeks.org/problems/next-larger-element-1587115620/1",
    videoUrl: "https://www.youtube.com/watch?v=Du881K7Jtk8",
    notesUrl: "https://takeuforward.org/data-structure/next-greater-element-using-stack/",
    hasDiscussion: true
  },
  {
    id: 43,
    title: "Swap Nodes in Pairs",
    difficulty: "Medium",
    topics: ["Linked List", "Recursion"],
    companies: ["Google", "Amazon", "Microsoft", "Netflix"],
    status: "Attempted",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/swap-nodes-in-pairs/",
    videoUrl: "https://youtu.be/o811TZLAWOo",
    notesUrl: "https://leetcode.com/problems/swap-nodes-in-pairs/solution/",
    hasDiscussion: true
  },
  {
    id: 44,
    title: "LRU Cache",
    difficulty: "Hard",
    topics: ["Design", "Hash Table", "Linked List", "Doubly-Linked List"],
    companies: ["Google", "Amazon", "Microsoft"],
    status: "Unsolved",
    points: 25,
    platform: "CodingNinjas",
    platformUrl: "https://www.codingninjas.com/studio/problems/lru-cache_631770",
    videoUrl: "https://www.youtube.com/watch?v=xDEuM5qa0zg",
    notesUrl: "https://takeuforward.org/data-structure/implement-lru-cache/",
    hasDiscussion: true
  },
  {
    id: 45,
    title: "Reverse Nodes in k-Group",
    difficulty: "Hard",
    topics: ["Linked List", "Recursion"],
    companies: ["LinkedIn", "Oracle", "Airbnb", "Google"],
    status: "Unsolved",
    points: 25,
    leetcodeUrl: "https://leetcode.com/problems/reverse-nodes-in-k-group/",
    videoUrl: "https://youtu.be/Of0HPkk3JgI",
    notesUrl: "https://takeuforward.org/data-structure/reverse-linked-list-in-groups-of-size-k/",
    hasDiscussion: true
  },
  {
    id: 46,
    title: "Binary Tree Inorder Traversal",
    difficulty: "Easy",
    topics: ["Tree", "Binary Tree", "DFS"],
    companies: ["Microsoft", "Amazon", "Facebook"],
    status: "Solved",
    points: 10,
    platform: "GeeksforGeeks",
    platformUrl: "https://www.geeksforgeeks.org/problems/inorder-traversal/1",
    videoUrl: "https://www.youtube.com/watch?v=Z_NEgBgbRVI",
    notesUrl: "https://takeuforward.org/data-structure/inorder-traversal-of-binary-tree/",
    hasDiscussion: true
  },
  {
    id: 47,
    title: "Remove Duplicates from Sorted Array",
    difficulty: "Easy",
    topics: ["Array", "Two Pointers"],
    companies: ["Facebook", "Uber", "Twitter", "LinkedIn"],
    status: "Solved",
    points: 10,
    leetcodeUrl: "https://leetcode.com/problems/remove-duplicates-from-sorted-array/",
    videoUrl: "https://youtu.be/Fm_p9lJ4Z_8",
    notesUrl: "https://takeuforward.org/data-structure/remove-duplicates-in-place-from-sorted-array/",
    hasDiscussion: true
  },
  {
    id: 48,
    title: "Level Order Traversal",
    difficulty: "Medium",
    topics: ["Tree", "Binary Tree", "BFS"],
    companies: ["Amazon", "Microsoft", "Adobe"],
    status: "Solved",
    points: 15,
    platform: "CodingNinjas",
    platformUrl: "https://www.codingninjas.com/studio/problems/level-order-traversal_796002",
    videoUrl: "https://www.youtube.com/watch?v=EoAsWbO7sqg",
    notesUrl: "https://takeuforward.org/data-structure/level-order-traversal-of-a-binary-tree/",
    hasDiscussion: true
  },
  {
    id: 49,
    title: "Remove Element",
    difficulty: "Easy",
    topics: ["Array", "Two Pointers"],
    companies: ["Google", "Amazon", "Microsoft", "Adobe"],
    status: "Solved",
    points: 10,
    leetcodeUrl: "https://leetcode.com/problems/remove-element/",
    videoUrl: "https://youtu.be/Pcd1ii9P9ZI",
    notesUrl: "https://leetcode.com/problems/remove-element/solution/",
    hasDiscussion: true
  },
  {
    id: 50,
    title: "Diameter of Binary Tree",
    difficulty: "Easy",
    topics: ["Tree", "Binary Tree", "DFS"],
    companies: ["Amazon", "Microsoft", "Facebook"],
    status: "Solved",
    points: 10,
    platform: "GeeksforGeeks",
    platformUrl: "https://www.geeksforgeeks.org/problems/diameter-of-binary-tree/1",
    videoUrl: "https://www.youtube.com/watch?v=Rezetez59Nk",
    notesUrl: "https://takeuforward.org/data-structure/calculate-the-diameter-of-a-binary-tree/",
    hasDiscussion: true
  },
  {
    id: 51,
    title: "Implement strStr()",
    difficulty: "Easy",
    topics: ["String", "Two Pointers"],
    companies: ["Oracle", "Facebook", "Airbnb", "Netflix"],
    status: "Solved",
    points: 10,
    leetcodeUrl: "https://leetcode.com/problems/implement-strstr/",
    videoUrl: "https://youtu.be/JoF0Z7nVSrA",
    notesUrl: "https://leetcode.com/problems/implement-strstr/solution/",
    hasDiscussion: true
  },
  {
    id: 52,
    title: "Lowest Common Ancestor",
    difficulty: "Medium",
    topics: ["Tree", "Binary Tree", "DFS"],
    companies: ["Amazon", "Microsoft", "Google"],
    status: "Attempted",
    points: 15,
    platform: "CodingNinjas",
    platformUrl: "https://www.codingninjas.com/studio/problems/lowest-common-ancestor_628702",
    videoUrl: "https://www.youtube.com/watch?v=_-QHfMDde90",
    notesUrl: "https://takeuforward.org/data-structure/lowest-common-ancestor-for-two-given-nodes/",
    hasDiscussion: true
  },
  {
    id: 53,
    title: "Divide Two Integers",
    difficulty: "Medium",
    topics: ["Math", "Bit Manipulation"],
    companies: ["Apple", "Uber", "Twitter", "Facebook"],
    status: "Attempted",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/divide-two-integers/",
    videoUrl: "https://youtu.be/m41rifGp11E",
    notesUrl: "https://leetcode.com/problems/divide-two-integers/solution/",
    hasDiscussion: true
  },
  {
    id: 54,
    title: "Validate Binary Search Tree",
    difficulty: "Medium",
    topics: ["Tree", "Binary Search Tree", "DFS"],
    companies: ["Amazon", "Microsoft", "Bloomberg"],
    status: "Attempted",
    points: 15,
    platform: "GeeksforGeeks",
    platformUrl: "https://www.geeksforgeeks.org/problems/check-for-bst/1",
    videoUrl: "https://www.youtube.com/watch?v=f-sj7I5oXEI",
    notesUrl: "https://takeuforward.org/data-structure/check-if-a-tree-is-a-binary-search-tree-or-binary-tree/",
    hasDiscussion: true
  },
  {
    id: 55,
    title: "Find the Index of the First Occurrence in a String",
    difficulty: "Easy",
    topics: ["String", "Two Pointers", "String Matching"],
    companies: ["Airbnb", "Microsoft", "Google", "Adobe"],
    status: "Solved",
    points: 10,
    leetcodeUrl: "https://leetcode.com/problems/find-the-index-of-the-first-occurrence-in-a-string/",
    videoUrl: "https://youtu.be/JoF0Z7nVSrA",
    notesUrl: "https://leetcode.com/problems/find-the-index-of-the-first-occurrence-in-a-string/solution/",
    hasDiscussion: true
  },
  {
    id: 56,
    title: "Detect Cycle in Directed Graph",
    difficulty: "Medium",
    topics: ["Graph", "DFS", "BFS", "Topological Sort"],
    companies: ["Amazon", "Microsoft", "Google"],
    status: "Attempted",
    points: 20,
    platform: "CodingNinjas",
    platformUrl: "https://www.codingninjas.com/studio/problems/detect-cycle-in-a-directed-graph_1062626",
    videoUrl: "https://www.youtube.com/watch?v=9twcmtQj4DU",
    notesUrl: "https://takeuforward.org/data-structure/detect-a-cycle-in-directed-graph-topological-sort-kahns-algorithm-g-23/",
    hasDiscussion: true
  },
  {
    id: 57,
    title: "Search Insert Position",
    difficulty: "Easy",
    topics: ["Array", "Binary Search"],
    companies: ["Adobe", "Uber", "LinkedIn", "Twitter"],
    status: "Solved",
    points: 10,
    leetcodeUrl: "https://leetcode.com/problems/search-insert-position/",
    videoUrl: "https://youtu.be/K-RYzDZkzCI",
    notesUrl: "https://takeuforward.org/arrays/search-insert-position/",
    hasDiscussion: true
  },
  {
    id: 58,
    title: "Topological Sort",
    difficulty: "Medium",
    topics: ["Graph", "DFS", "BFS", "Topological Sort"],
    companies: ["Amazon", "Microsoft", "Adobe"],
    status: "Attempted",
    points: 15,
    platform: "GeeksforGeeks",
    platformUrl: "https://www.geeksforgeeks.org/problems/topological-sort/1",
    videoUrl: "https://www.youtube.com/watch?v=5lZ0iJMrUMk",
    notesUrl: "https://takeuforward.org/data-structure/topological-sort-algorithm-dfs-g-21/",
    hasDiscussion: true
  },
  {
    id: 59,
    title: "Count and Say",
    difficulty: "Medium",
    topics: ["String"],
    companies: ["Apple", "Amazon", "Oracle", "Adobe"],
    status: "Attempted",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/count-and-say/",
    videoUrl: "https://youtu.be/1YUqzlPaWpQ",
    notesUrl: "https://leetcode.com/problems/count-and-say/solution/",
    hasDiscussion: true
  },
  {
    id: 60,
    title: "Dijkstra's Shortest Path",
    difficulty: "Medium",
    topics: ["Graph", "Shortest Path", "Heap"],
    companies: ["Google", "Amazon", "Microsoft"],
    status: "Attempted",
    points: 20,
    platform: "CodingNinjas",
    platformUrl: "https://www.codingninjas.com/studio/problems/dijkstra-s-shortest-path_920469",
    videoUrl: "https://www.youtube.com/watch?v=V6H1qAeB-l4",
    notesUrl: "https://takeuforward.org/data-structure/dijkstras-algorithm-using-priority-queue-g-32/",
    hasDiscussion: true
  },
  {
    id: 61,
    title: "Combination Sum",
    difficulty: "Medium",
    topics: ["Array", "Backtracking"],
    companies: ["Airbnb", "Twitter", "Microsoft"],
    status: "Attempted",
    points: 20,
    leetcodeUrl: "https://leetcode.com/problems/combination-sum/",
    videoUrl: "https://youtu.be/GBKI9VSKdGg",
    notesUrl: "https://takeuforward.org/data-structure/combination-sum-1/",
    hasDiscussion: true
  },
  {
    id: 62,
    title: "Combination Sum II",
    difficulty: "Medium",
    topics: ["Array", "Backtracking"],
    companies: ["Netflix", "Google", "LinkedIn"],
    status: "Unsolved",
    points: 20,
    leetcodeUrl: "https://leetcode.com/problems/combination-sum-ii/",
    videoUrl: "https://youtu.be/G1fRTGRxXU8",
    notesUrl: "https://takeuforward.org/data-structure/combination-sum-ii-find-all-unique-combinations/",
    hasDiscussion: true
  },
  {
    id: 63,
    title: "First Missing Positive",
    difficulty: "Hard",
    topics: ["Array"],
    companies: ["Amazon", "Netflix", "Facebook"],
    status: "Unsolved",
    points: 25,
    leetcodeUrl: "https://leetcode.com/problems/first-missing-positive/",
    videoUrl: "https://youtu.be/8g78yfzMlao",
    notesUrl: "https://leetcode.com/problems/first-missing-positive/solution/",
    hasDiscussion: true
  },
  {
    id: 64,
    title: "Trapping Rain Water",
    difficulty: "Hard",
    topics: ["Array", "Two Pointers", "Dynamic Programming", "Stack"],
    companies: ["Oracle", "Apple", "Twitter"],
    status: "Attempted",
    points: 25,
    leetcodeUrl: "https://leetcode.com/problems/trapping-rain-water/",
    videoUrl: "https://youtu.be/m18Hntz4go8",
    notesUrl: "https://takeuforward.org/data-structure/trapping-rainwater/",
    hasDiscussion: true
  },
  {
    id: 65,
    title: "Multiply Strings",
    difficulty: "Medium",
    topics: ["Math", "String", "Simulation"],
    companies: ["Uber", "Amazon", "Facebook"],
    status: "Attempted",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/multiply-strings/",
    videoUrl: "https://youtu.be/1vZswirL8Y8",
    notesUrl: "https://leetcode.com/problems/multiply-strings/solution/",
    hasDiscussion: true
  },
  {
    id: 66,
    title: "Permutations",
    difficulty: "Medium",
    topics: ["Array", "Backtracking"],
    companies: ["Google", "Microsoft", "LinkedIn"],
    status: "Attempted",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/permutations/",
    videoUrl: "https://youtu.be/YK78FU5Ffjw",
    notesUrl: "https://takeuforward.org/data-structure/print-all-permutations-of-a-string-array/",
    hasDiscussion: true
  },
  {
    id: 67,
    title: "Rotate Image",
    difficulty: "Medium",
    topics: ["Array", "Math", "Matrix"],
    companies: ["Oracle", "Airbnb", "Apple"],
    status: "Attempted",
    points: 20,
    leetcodeUrl: "https://leetcode.com/problems/rotate-image/",
    videoUrl: "https://youtu.be/Y72QeX0EfxY",
    notesUrl: "https://takeuforward.org/data-structure/rotate-image-by-90-degree/",
    hasDiscussion: true
  },
  {
    id: 68,
    title: "Group Anagrams",
    difficulty: "Medium",
    topics: ["Hash Table", "String", "Sorting"],
    companies: ["Netflix", "Adobe", "Microsoft"],
    status: "Attempted",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/group-anagrams/",
    videoUrl: "https://youtu.be/vzdQCs79ILg",
    notesUrl: "https://takeuforward.org/data-structure/group-anagrams/",
    hasDiscussion: true
  },
  {
    id: 69,
    title: "Pow(x, n)",
    difficulty: "Medium",
    topics: ["Math", "Recursion"],
    companies: ["Uber", "Airbnb", "Apple"],
    status: "Attempted",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/powx-n/",
    videoUrl: "https://youtu.be/l0jCyaYcKUE",
    notesUrl: "https://takeuforward.org/data-structure/implement-powxn-x-raised-to-the-power-n/",
    hasDiscussion: true
  },
  {
    id: 70,
    title: "Maximum Subarray",
    difficulty: "Easy",
    topics: ["Array", "Divide and Conquer", "Dynamic Programming"],
    companies: ["Amazon", "Twitter", "Netflix"],
    status: "Solved",
    points: 10,
    leetcodeUrl: "https://leetcode.com/problems/maximum-subarray/",
    videoUrl: "https://youtu.be/AHZpyENo7k4",
    notesUrl: "https://takeuforward.org/data-structure/kadanes-algorithm-maximum-subarray-sum-in-an-array/",
    hasDiscussion: true
  },
  {
    id: 71,
    title: "Spiral Matrix",
    difficulty: "Medium",
    topics: ["Array", "Matrix", "Simulation"],
    companies: ["Google", "Facebook", "Uber"],
    status: "Attempted",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/spiral-matrix/",
    videoUrl: "https://youtu.be/3JyUIXSlgaA",
    notesUrl: "https://takeuforward.org/data-structure/spiral-traversal-of-matrix/",
    hasDiscussion: true
  },
  {
    id: 72,
    title: "Jump Game",
    difficulty: "Medium",
    topics: ["Array", "Greedy", "Dynamic Programming"],
    companies: ["Adobe", "LinkedIn", "Microsoft"],
    status: "Attempted",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/jump-game/",
    videoUrl: "https://youtu.be/Yan0cv2cLy8",
    notesUrl: "https://leetcode.com/problems/jump-game/solution/",
    hasDiscussion: true
  },
  {
    id: 73,
    title: "Merge Intervals",
    difficulty: "Medium",
    topics: ["Array", "Sorting"],
    companies: ["Adobe", "Amazon", "Oracle"],
    status: "Attempted",
    points: 20,
    leetcodeUrl: "https://leetcode.com/problems/merge-intervals/",
    videoUrl: "https://youtu.be/IexN60k62jo",
    notesUrl: "https://takeuforward.org/data-structure/merge-overlapping-sub-intervals/",
    hasDiscussion: true
  },
  {
    id: 74,
    title: "Insert Interval",
    difficulty: "Medium",
    topics: ["Array"],
    companies: ["Apple", "Netflix", "LinkedIn"],
    status: "Attempted",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/insert-interval/",
    videoUrl: "https://youtu.be/xxRE-46YXDk",
    notesUrl: "https://takeuforward.org/data-structure/insert-interval/",
    hasDiscussion: true
  },
  {
    id: 75,
    title: "Length of Last Word",
    difficulty: "Easy",
    topics: ["String"],
    companies: ["Facebook", "Twitter", "Google"],
    status: "Solved",
    points: 10,
    leetcodeUrl: "https://leetcode.com/problems/length-of-last-word/",
    videoUrl: "https://youtu.be/KT9rltZEyPs",
    notesUrl: "https://leetcode.com/problems/length-of-last-word/solution/",
    hasDiscussion: true
  },
  {
    id: 76,
    title: "Spiral Matrix II",
    difficulty: "Medium",
    topics: ["Array", "Matrix", "Simulation"],
    companies: ["Uber", "Oracle", "Airbnb"],
    status: "Attempted",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/spiral-matrix-ii/",
    videoUrl: "https://youtu.be/dtR53w6b91E",
    notesUrl: "https://leetcode.com/problems/spiral-matrix-ii/solution/",
    hasDiscussion: true
  },
  {
    id: 77,
    title: "Permutation Sequence",
    difficulty: "Hard",
    topics: ["Math", "Recursion"],
    companies: ["Oracle", "Uber", "Adobe"],
    status: "Unsolved",
    points: 25,
    leetcodeUrl: "https://leetcode.com/problems/permutation-sequence/",
    videoUrl: "https://youtu.be/wT7gcXLYoao",
    notesUrl: "https://takeuforward.org/data-structure/find-k-th-permutation-sequence/",
    hasDiscussion: true
  },
  {
    id: 78,
    title: "Rotate List",
    difficulty: "Medium",
    topics: ["Linked List", "Two Pointers"],
    companies: ["Netflix", "Google", "LinkedIn"],
    status: "Attempted",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/rotate-list/",
    videoUrl: "https://youtu.be/9VPm6nEbVPA",
    notesUrl: "https://takeuforward.org/data-structure/rotate-a-linked-list/",
    hasDiscussion: true
  },
  {
    id: 79,
    title: "Unique Paths",
    difficulty: "Medium",
    topics: ["Math", "Dynamic Programming", "Combinatorics"],
    companies: ["Facebook", "Airbnb", "Apple"],
    status: "Attempted",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/unique-paths/",
    videoUrl: "https://youtu.be/t_f0nwwdg5o",
    notesUrl: "https://takeuforward.org/data-structure/grid-unique-paths-dp-on-grids-dp-8/",
    hasDiscussion: true
  },
  {
    id: 80,
    title: "Unique Paths II",
    difficulty: "Medium",
    topics: ["Array", "Dynamic Programming", "Matrix"],
    companies: ["Twitter", "Amazon", "Microsoft"],
    status: "Attempted",
    points: 15,
    leetcodeUrl: "https://leetcode.com/problems/unique-paths-ii/",
    videoUrl: "https://youtu.be/TmhpgXScLyY",
    notesUrl: "https://takeuforward.org/data-structure/grid-unique-paths-2-dp-9/",
    hasDiscussion: true
  }
];

export { problems };
